import {Button} from "@material-tailwind/react";
import React from "react";
import SelectInput from "../../system/select";
import {getPersonsNameAndFamily} from "../../../services/profile/profile";
import {getAgentsList} from "../../../services/agent/agent";
import {getFields} from "../../../services/field/field";
import {getFieldBranchesByFieldId} from "../../../services/branch/branch";
import FromToNumberField from "../../system/fromToNumberField";
import FromToDateField from "../../system/fromToDateField";

const SERVICE_STATUS_OPTIONS = [
  {
    id: "new",
    title: "در انتظار تکمیل مدارک",
  },
  {
    id: "payment",
    title: "در انتظار پرداخت",
  },
  {
    id: "waiting",
    title: "درحال انجام",
  },
  {
    id: "finish",
    title: "اتمام خدمت",
  },
];

export function ServiceReportFilterContainer({
                                              personId,
                                              setPersonId,
                                              agentId,
                                              setAgentId,
                                              fieldId,
                                              setFieldId,
                                              branchId,
                                              setBranchId,
                                              status,
                                              setStatus,
                                              minPrice,
                                              setMinPrice,
                                              maxPrice,
                                              setMaxPrice,
                                              createdAtFrom,
                                              setCreatedAtFrom,
                                              createdAtTo,
                                              setCreatedAtTo,
                                              paidAtFrom,
                                              setPaidAtFrom,
                                              paidAtTo,
                                              setPaidAtTo,
                                              loading,
                                              hasRows,
                                              isExporting,
                                              onClear,
                                              onExport,
                                            }) {
  return (
    <>
      <div className="grid grid-cols-1 gap-4 mb-8 md:grid-cols-3 xxl:grid-cols-3">
        <div className="flex flex-col">
          <SelectInput
            label={"کاربر"}
            defaultValue={personId}
            refreshSignal={personId}
            autoLoadService={getPersonsNameAndFamily}
            autoLoadRender={({name, family, phone}) => {
              const fullName = `${name?.trim()} ${family?.trim()}`.trim();
              return fullName + " - " + phone
            }}
            onChange={setPersonId}
          />
        </div>

        <div className="flex flex-col">
          <SelectInput
            label={"مباشر"}
            defaultValue={agentId}
            refreshSignal={agentId}
            autoLoadService={getAgentsList}
            autoLoadRender={({name, family}) => `${name?.trim()} ${family?.trim()}`.trim()}
            onChange={setAgentId}
          />
        </div>

        <div className="flex flex-col">
          <SelectInput
            label={"رشته"}
            defaultValue={fieldId}
            autoLoadService={getFields}
            onChange={setFieldId}
          />
        </div>

        <div className="flex flex-col">
          <SelectInput
            label={"گرایش"}
            defaultValue={branchId}
            refreshSignal={fieldId}
            autoLoadService={getFieldBranchesByFieldId}
            autoLoadServiceData={fieldId}
            autoLoadRender={({title}) => title}
            onChange={setBranchId}
          />
        </div>

        <div className="flex flex-col">
          <SelectInput
            label={"وضعیت"}
            defaultValue={status}
            refreshSignal={status}
            options={SERVICE_STATUS_OPTIONS}
            onChange={setStatus}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-1 mb-4 md:grid-cols-2 xxl:grid-cols-2">
        <FromToNumberField
          label="مبلغ"
          fromNumber={minPrice}
          setFromNumber={setMinPrice}
          toNumber={maxPrice}
          setToNumber={setMaxPrice}
        />

        <FromToDateField
          className="w-full"
          fromDate={createdAtFrom}
          setFromDate={setCreatedAtFrom}
          toDate={createdAtTo}
          setToDate={setCreatedAtTo}
          label="ایجاد"
        />

        <FromToDateField
          className="w-full"
          fromDate={paidAtFrom}
          setFromDate={setPaidAtFrom}
          toDate={paidAtTo}
          setToDate={setPaidAtTo}
          label="پرداخت"
        />
      </div>

      <div className="flex flex-row justify-between">
        <Button variant="gradient" color="gray" onClick={onClear} className="ml-1" disabled={loading}>
          <span>حذف فیلتر</span>
        </Button>

        {hasRows &&
          <Button size="sm" variant="outlined" onClick={onExport} disabled={isExporting}>
            {isExporting ? "در حال خروجی..." : "خروجی اکسل"}
          </Button>
        }
      </div>
    </>
  );
}
